package org.multiplatform.kotfolio.styles

import com.varabyte.kobweb.compose.css.FontSize
import org.multiplatform.kotfolio.util.Resources
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.content
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.navigation.LinkStyle
import com.varabyte.kobweb.silk.style.CssRule
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.plus
import com.varabyte.kobweb.silk.style.selectors.after
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.StylePropertyValue
import org.jetbrains.compose.web.css.and
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val UnderLineLinkVariant = LinkStyle.addVariant {
    base {
        Modifier
            .position(Position.Relative)
    }

    hover {
        Modifier.textDecorationLine(TextDecorationLine.None)
    }

    val noReducedMotion = (Breakpoint.MD.toCSSMediaQuery() as CSSMediaQuery.Atomic)
        .and(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference")))

    val prefersReducedMotion = (Breakpoint.MD.toCSSMediaQuery() as CSSMediaQuery.Atomic)
        .and(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("reduce")))

    (Breakpoint.MD + after) {
        Modifier
            .content("")
            .backgroundColor( Resources.Colors.FOOTER_COLOR_LIGHT)
            .bottom((-1).px)
            .left(0.px)
            .height(1.px)
            .fillMaxWidth()
            .position(Position.Absolute)
    }

    (CssRule.OfMedia(noReducedMotion) + after) {
        Modifier
            .transform { scaleX(0) }
            .transition(Transition.of("transform", 0.35.s, TransitionTimingFunction.Ease))
    }

    (CssRule.OfMedia(noReducedMotion) + hover + after) {
        Modifier.transform { scaleX(1) }
    }

    (CssRule.OfMedia(prefersReducedMotion) + after) {
        Modifier
            .opacity(0)
            .transition(Transition.of("opacity", 0.35.s, TransitionTimingFunction.Ease))
    }

    (CssRule.OfMedia(prefersReducedMotion) + hover + after) {
        Modifier.opacity(1)
    }
}
